<template>
  <div>
    <vue-element-loading :active="appLoading" :is-full-screen="true" />
    <ServerError v-if="ServerError" />
    <v-snackbar v-model="showSnackBar" color="#63028F" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{msg}}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon style="color:white;">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout wrap justify-space-between>
      <v-flex xs6 md10 text-left>
        <span style="font-family:opensansextrabold;font-size:18px">
          <v-icon style="color:black;font-size:14px;">mdi-circle-outline</v-icon>&nbsp;Edit Product
        </span>
      </v-flex>
    </v-layout>
    <br />
    <v-card class="mx-auto" outlined>
      <v-layout wrap pt-3>
        <v-flex md1 lg1>
          <v-img src="./../../../assets/webpeedika.png" aspect-ratio="1" contain height="30px"></v-img>
        </v-flex>
        <v-flex xs12 md10 lg10 pb-3>
          <v-layout wrap>
            <v-flex xs12 md7 lg7 text-left>
              <v-layout wrap>
                <v-flex px-2 xs12>
                  <span
                    style="padding-left:10px;font-family:opensansextrabold;font-size:12px;"
                  >Name of the Product</span>
                  <v-text-field
                    placeholder="Product Name"
                    readonly
                    style="max-height: 46px!important;"
                    v-model="productData.productname"
                    outlined
                    color="#63028F"
                    dense
                  ></v-text-field>
                </v-flex>
                <v-flex px-2 xs12 md3 lg3>
                  <span style="font-family:opensansextrabold;font-size:12px;" class="pl-2">Unit</span>
                  <v-text-field
                    placeholder="Weight"
                    readonly
                    disabled
                    v-model="productData.unit"
                    outlined
                    color="#63028F"
                    dense
                  ></v-text-field>
                </v-flex>
                <v-flex px-2 xs12 md3 lg3>
                  <span style="font-family:opensansextrabold;font-size:12px;" class="pl-2">Stock</span>
                  <v-text-field
                    placeholder="Stock"
                    v-model="productData.stockquantity"
                    outlined
                    color="#63028F"
                    dense
                  ></v-text-field>
                </v-flex>
                <v-flex px-2 md3 lg3>
                  <span
                    style="text-align:left;font-family:opensansextrabold;font-size:12px;"
                    class="pl-2"
                  >Price</span>
                  <v-text-field
                    placeholder="Price"
                    type="number"
                    v-model="productData.price"
                    outlined
                    color="#63028F"
                    dense
                  ></v-text-field>
                </v-flex>
                <v-flex px-2 md3 lg3>
                  <span
                    style="text-align:left;font-family:opensansextrabold;font-size:12px;"
                    class="pl-2"
                  >Offer %</span>
                  <v-text-field
                    placeholder="Discount %"
                    style="max-height: 46px!important;"
                    type="number"
                    v-model="productData.discountpercentage"
                    max="100"
                    outlined
                    color="#63028F"
                    dense
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex md2 lg2 px-2 text-left>
              <v-layout wrap>
                <v-flex xs12 px-2>
                  <v-radio-group v-model="productData.instock">
                    <span
                      style="font-family:opensansextrabold;font-size:12px;"
                      class="pl-1 pb-2"
                    >Status</span>
                    <v-radio label="Active" :value="true" color="#63028F" :ripple="false"></v-radio>
                    <v-radio label="Inactive" :value="false" color="#63028F" :ripple="false"></v-radio>
                  </v-radio-group>
                </v-flex>
                <v-flex xs12 align-self-baseline>
                  <v-btn
                    block
                    small
                    dark
                    :color="productData.instock ? '#FFBC6E' : '#EB6359'"
                    depressed
                    class="text-capitalize"
                    :ripple="false"
                  >
                    <span v-if="productData.instock">
                      <v-icon style="color:white;">mdi-check</v-icon>Available
                    </span>
                    <span v-else>
                      <v-icon style="color:white;">mdi-close</v-icon>Out of Stock
                    </span>
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex md3 lg3 pl-3 text-left>
              <v-card pr-4flat tile outlined>
                <v-layout wrap>
                  <v-flex md4 lg4>
                    <v-img :src="baseURL+'/u/'+productData.photos[0]" height="113px" contain>
                      <template v-slot:placeholder>
                        <v-row class="fill-height ma-0" align="center" justify="center">
                          <v-progress-circular indeterminate color="#26af82"></v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                  </v-flex>
                  <v-flex pl-2 md6 lg6>
                    <v-layout wrap>
                      <v-flex
                        pt-2
                        md6
                        v-for="(item,i) in productData.photos"
                        :key="i"
                        px-2
                        class="hidden-sm-and-down"
                      >
                        <v-img v-if="item" :src="baseURL+'/u/'+item" height="44px" width="44px">
                          <template v-slot:placeholder>
                            <v-row class="fill-height ma-0" align="center" justify="center">
                              <v-progress-circular indeterminate color="#26af82"></v-progress-circular>
                            </v-row>
                          </template>
                        </v-img>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-card>
              <br />
              <span>
                <v-btn
                  small
                  :ripple="false"
                  id="pro_pic"
                  class="text-capitalize"
                  color="#EFEFEF "
                  width="80%"
                  @click="$refs.files.click()"
                >
                  <span style="font-size:12px">Upload Image</span>
                  <v-img
                    src="./../../../assets/images/fileupload.png"
                    aspect-ratio="1"
                    contain
                    height="20px"
                  ></v-img>
                </v-btn>
                <input
                  v-show="false"
                  accept="image/*"
                  id="file"
                  ref="files"
                  multiple="multiple"
                  type="file"
                  @change="uploadImages"
                />
              </span>
            </v-flex>
          </v-layout>
          <v-layout wrap justify-center>
            <v-flex px-2 py-3 xs12>
              <v-divider></v-divider>
            </v-flex>
          </v-layout>
          <v-layout pt-3 wrap justify-space-between>
            <v-flex px-2 md3 lg3 align-self-center>
              <v-text-field
                dense
                v-model="productData.productcode"
                label="Product ID "
                style="max-height: 46px!important;"
                color="#63028F"
                hide-details
              ></v-text-field>
            </v-flex>
            <v-flex px-2 xs12 md3 lg3 align-self-center>
              <span
                style="font-family:opensansregular;font-size:14px;color:#616161"
              >Item Added {{formatDate(productData.account_create_at)}}</span>
            </v-flex>
            <v-flex px-2 xs12 md3 lg3 text-right>
              <v-btn
                block
                dark
                color="#63028F"
                depressed
                class="text-capitalize"
                :ripple="false"
                @click="editProduct"
              >Apply</v-btn>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex md1 lg1>
          <v-img
            src="./../../../assets/images/savedIcon.png"
            aspect-ratio="1"
            contain
            height="30px"
          ></v-img>
        </v-flex>
      </v-layout>
    </v-card>
  </div>
</template>
<script>
import axios from "axios";
import store from "./../../../store";
export default {
  props: ["product"],
  data() {
    return {
      appLoading: false,
      ServerError: false,
      showSnackBar: false,
      timeout: 5000,
      msg: "",
      image: null,
      imageArray: [],
      Images: new FormData(),
      selectedFiles: null,
    };
  },
  beforeMount() {
    this.productData = this.product;
    Number(this.productData.discountpercentage);
  },
  methods: {
    appLogout() {
      store.commit("logoutUser", true);
    },
    uploadImages(event) {
      this.selectedFiles = event.target.files[0];
      this.Images.append("image", this.selectedFiles);
      console.log("files", this.Images);
      var img;
      img = new Image();
      img.src = window.URL.createObjectURL(event.target.files[0]);
      img.onload = () => {
        const urls = URL.createObjectURL(this.selectedFiles);
        if (this.imageArray.length < 4) {
          this.imageArray.push(urls);
        } else {
          this.msg = "Four Images Already Added!";
          //this.showSnackBar = true;
        }
        if (this.imageArray) {
          this.image = this.imageArray[0];
        }
      };
    },
    editProduct() {
      this.appLoading = true;
      this.productData.id = this.productData._id;
      this.productData.offer = Number(this.productData.discountpercentage);
      axios({
        method: "POST",
        url: "/product/Edit",
        data: this.productData,
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.$emit("stepper", {
              getList: true,
              editProduct: false,
            });
            this.showSnackBar = true;
            this.msg = response.data.msg;
          } else {
            // this.$emit("stepper", {
            //   getList: true,
            // });
            this.showSnackBar = true;
            this.msg = response.data.msg;
          }
        })
        .catch((err) => {
          this.ServerError = true;
          console.log(err);
        });
    },
    formatDate(item) {
      var dt = new Date(item);
      var day = dt.getDate();
      var year = dt.getFullYear();
      var hours = dt.getHours();
      var minutes = dt.getMinutes();
      dt = dt.toString();
      var ampm = hours >= 12 ? "pm" : "am";
      hours = hours % 12;
      hours = hours ? hours : 12;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      var strTime =
        day +
        " " +
        dt.slice(4, 7) +
        " " +
        year +
        " " +
        hours +
        ":" +
        minutes +
        " " +
        ampm;
      return strTime;
    },
  },
};
</script>
<style  scoped>
.v-input__slot {
  min-height: 36px;
}
</style>